import nexus from '@ospin/nexus'
import { deleteAllUserDeviceAlerts } from '~/redux/actions/actions'

const callDeleteManyDeviceAlertsByDeviceId = async (dispatch, deviceIds) => {
  await Promise.all(deviceIds.map(deviceId => nexus.event.device.removeAll({ deviceId })))
  dispatch(deleteAllUserDeviceAlerts(deviceIds))
}

export default callDeleteManyDeviceAlertsByDeviceId
